import React from "react";
import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";

export default function BookCard({ book }) {

    const handleOpenPDF = () => {
        window.open(book.pdf, "_blank");
    };

    return (
        <Card
            onClick={handleOpenPDF}
            sx={{
                width: 250,
                borderRadius: 2,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                    boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
                    transform: "translateY(-4px)",
                },
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                <CardMedia
                    component="img"
                    height="180"
                    image={book.image}
                    alt={book.title}
                    sx={{
                        borderRadius: 1,
                        objectFit: "contain",
                        width: "100%",
                    }}
                />
            </Box>

            <CardContent sx={{ textAlign: "center", pt: 0 }}>
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "break",
                    }}
                >
                    {book.title}
                </Typography>
            </CardContent>
        </Card>
    );
}
